if (typeof discount_per_arr != 'undefined' && discount_per_arr instanceof Array ){
for(var index in discount_per_arr){
jQuery('#disc-per'+index).text(discount_per_arr[index]);
}
}
function onOptionChange() {
  cp = parseFloat($('.product-main .old-price .money').text().replace("₹ ","").replace(",",""));
  sp = parseFloat($('.product-main .sale-price .money').text().replace("₹ ","").replace(",",""));
  if(cp>sp) {
    perc = ((cp-sp)/cp)*100;
    $('#discount_per').text(Math.round(perc)+'% off');
    $('.product-main #discount_per').show();
    $('.product-main .product-price .old-price').show();
  }
  else {
    $('.product-main #discount_per').hide();
    $('.product-main .product-price .old-price').hide();
  }
}
$(document).ready(function(){
onOptionChange();})

jQuery('.option-label').click(function(){
  setTimeout(function() {
    onOptionChange();
  }, 100);
})

jQuery('.banner1').click(function(){window.location.href="https://www.caninkart.com/collections/bedding-mats";});
jQuery('.banner2').click(function(){window.location.href="https://www.caninkart.com/collections/toy-combos";});
jQuery('.slide-1578993962751-0').click(function(){window.location.href="https://www.caninkart.com/collections/bow-ties-bandana";});
jQuery('.slide-1578993962751-1').click(function(){window.location.href="https://www.caninkart.com/collections/bedding-mats";});
jQuery('.slide-08c702ab-2745-472b-bd73-bb0bb7ea3e6c').click(function(){window.location.href="https://www.caninkart.com/collections/dog-bowls-diners";});